import type { Strategy } from './types'

export const strategies: Strategy[] = [
  {
    id: 'community-validation',
    title: 'Community Led Design & Development',
    tagline: 'Validation from the communities we serve is the foundation everything else is built on',
    priority: 'primary',
    whyPrimary:
      'Without community validation, there is no project. Indigenous digital infrastructure must be built by Indigenous communities to reflect Indigenous values — not adapted from Western models. Growing contributors across all three houses and engaging communities as co-owners proves this isn\'t theoretical. It\'s a movement from research to reality.',
    approach: [
      'Grow active contributors across all three houses (Elders Council, Community House, Contributor House)',
      'Engage Indigenous communities as investors and co-designers, not just users — every tool co-designed with the communities it serves',
      'Release the Matou Technology Blueprint as proof of the research-to-reality pipeline',
      'Open contribution pathways (GitLab repos, docs, issue templates) so communities can participate in building their own digital tools',
      'Community feedback loops and co-design cycles built into every decision',
      'Build relationships with industry partners who share the vision of community-sovereign infrastructure',
    ],
    objectiveThemes: ['E', 'A', 'D'],
  },
  {
    id: 'tikanga-governance',
    title: 'Tikanga-Grounded Governance',
    tagline: 'Indigenous governance principles as the foundation, not an overlay',
    priority: 'supporting',
    approach: [
      'Three-house model (Elders Council, Community House, Contributor House) as the governance default',
      'Establish the Elders Council as a near-term priority (currently not active)',
      'Quadratic voting to prevent plutocratic capture',
      'Cultural values checklist applied to all design and technical decisions',
    ],
    objectiveThemes: ['D', 'E'],
  },
  {
    id: 'open-source-ecosystem',
    title: 'Open-Source Ecosystem Building',
    tagline: 'Forkable infrastructure designed for global Indigenous adoption from day one',
    priority: 'supporting',
    approach: [
      'Modular architecture so communities can adopt pieces independently',
      'Matou Technology Blueprint as a reusable template for any Indigenous governance context',
      'Open GitLab repos with clear contribution pathways',
      'Build relationships with industry partners for collaboration and shared infrastructure',
    ],
    objectiveThemes: ['A', 'E'],
  },
  {
    id: 'token-economy',
    title: 'Sustainable Token Economy',
    tagline: 'Three-token model to create a self-sustaining economic loop',
    priority: 'future',
    approach: [
      'Token or voucher launch by Q4 2026 (critical — funding runway ends)',
      'Contribution-based rewards to retain and grow the team',
      'Full bonding curve and treasury distribution model developed as adoption grows',
      'Gradual transition from grant-funded to treasury-funded operations',
    ],
    objectiveThemes: ['C', 'E'],
  },
]
